import { createTheme } from "@mui/material";

let theme = createTheme({
  palette: {
    common:{
      white: '#FFFFFF',
    },   
    primary: {
      light: "#3baf91",
      main: "#45A09D",
      dark: "#32928F",
      darkGreen: "#2E5F62",
      lightGreen: "#E1E9DF",
      lighterGreen: "#F0F4EF",
      white: "#FFFFFF",
      black: "#000000",
      gray: "#CCCCCC",
      lightGray: "#F7F7F7",
      darkGray: "#777777",
      darkRed: "#F44336"
    },
    health: {
      green: "#88A80D",
      orange: "#FFA015",
      yellow: "#FFDB15"
    },
    chart: {
      purple: "#e834eb",
      blue: "#129faf",
      navy: "#1966d2",
      green: "#34a853",
      violet: "#7627bb",
      red: "#e64919"
    }
  },
  typography: {
    h5: {
      fontWeight: 500,
      fontSize: 26,
      letterSpacing: 0.5
    }
  },
  shape: {
    borderRadius: 8
  }
});

theme = createTheme(theme, {
  components: {
    MuiTab: {
      defaultProps: {
        disableRipple: true
      }
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: "#121E26"
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        label: {
          textTransform: "none"
        },
        contained: {
          boxShadow: "none",
          "&:active": {
            boxShadow: "none"
          }
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          marginLeft: '8px'
        },
        indicator: {
          height: 3,
          borderTopLeftRadius: 3,
          borderTopRightRadius: 3,
          backgroundColor: "#ffffff"
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
          margin: "0 16px ",
          minWidth: 0,
          padding: 0,
          opacity: 0.7,
          color: "#fff",
          [theme.breakpoints.up("md")]: {
            padding: 0,
            minWidth: 0, 
          },
          "&.Mui-selected": {
            opacity: 1, 
            color: "#fff",
          }
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: '8px'
        }
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          borderRadius: 4
        }
      }
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          backgroundColor: "#3A454F"
        }
      }
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontWeight: `${theme.typography.fontWeightMedium} `
        }
      }
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: "inherit",
          marginRight: 0,
          "& svg": {
            fontSize: 20
          }
        }
      }
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          width: 32,
          height: 32
        }
      }
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          position: "sticky",
          top: 0,
          zIndex: 2
        }
      }
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          height: "100%",
          overflowX: "inherit"
        }
      }
    }
  }
});

export { theme };
